define('TescoMobile_Iovation/js/model/device-fingerprint-config',[], function () {
  'use strict';

  return {
    isConfigLoaded: false,
    isRetryVersionEnabled: false,
    isFingerprintSaved: false,
    retryInterval: 500,
    maxRetries: 6
  };
});

